module.exports = {"id":"179591","name":"Pablo Hernández","rating":"73","photo":"./data/images/photos/2/179591.png","club":{"name":"Leeds Utd","logo":"./data/images/clubs/LeedsUtd.png"},"positions":["MG","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PabloHernandez0.json
// module id = 3345
// module chunks = 0